/** Matches Low / Med / High resolution colours on the project toolbar. */
export function zoomResolutionTierBackground(zoom: number): string {
  return zoom > 20 ? "green" : zoom < 20 ? "orange" : "yellow"
}

export function zoomResolutionTierLabel(zoom: number): "Low" | "Med" | "High" {
  return zoom > 20 ? "High" : zoom < 20 ? "Low" : "Med"
}
